import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { ApiResponse } from '../interfaces';
import { User } from '../models';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private apiService: ApiService) {}

  getUserIdentity(): Promise<User> {
    return this.apiService
      .get(this.apiService.userIdentity)
      .pipe(map((response: ApiResponse) => response.data))
      .toPromise();
  }
}
